export const eventCategories = `
  data {
  id
    attributes {
      title
    }
  }
`;